import { attach, sample } from 'effector'
import { repairOrderModel } from '~/entities/RepairOrder'
import { editRepairOrderModel } from '~/features/RepairOrders/EditRepairOrder'
import { RepairOrder } from '~/shared/api'
import { OptionEnum } from '~/shared/config/constants'
import { RepairOrderPaymentStatusEnum } from '~/shared/config/enums'
import { snackbarEnqueued } from '~/shared/lib/notifications'
import { isString } from '~/shared/lib/utils'

export type StatusFormValues = {
  paymentStatus: OptionEnum<RepairOrderPaymentStatusEnum> | null
}

export const paymentStatusChangeFx = attach({
  effect: repairOrderModel.saveFx,
  source: editRepairOrderModel.$repairOrderId,
  mapParams: (paymentStatus: StatusFormValues['paymentStatus'], id) => {
    return new RepairOrder(
      {
        ...(isString(paymentStatus?.id) && { paymentStatus: paymentStatus.id }),
      },
      id as string,
    )
  },
})

sample({
  clock: paymentStatusChangeFx.doneData,
  fn() {
    return {
      messageI18n: 'alert.payment status successfully changed' as const,
      variant: 'success' as const,
    }
  },
  target: snackbarEnqueued,
})
